import type { Route } from "@ps-bridge/programs/routes";
import type { ClientID } from "@ps-bridge/models/brands/clientID";
import type { ProjectID } from "@ps-bridge/models/brands/projectID";
import * as routeProgram from "@ps-bridge/programs/routes";
import {
  renderRoute as renderRouteUnsafe,
  routeAccount,
  routeAdminPlan,
  routeAdminUsers,
  routeChooseSubscription,
  routeChooseSubscriptionWithStatus,
  routeClients,
  routeClientsExplorer,
  routeClientsExplorerWithClient,
  routeClientsExplorerWithProject,
  routeContextPreviewConsole,
  routeContextPreviewConsoleWithListing,
  routeCreateAccount,
  routeDemographicSurvey,
  routeDocumentCreation,
  routeDocumentDetailsPrompt,
  routeDocumentFinalEdits,
  routeDocumentFinalEditsWithContext,
  routeDocumentPrompt,
  routeDocumentRefine,
  routeDocumentRefineWithContext,
  routeDocumentSelection,
  routeEmailVerify,
  routeFeedback,
  routeHome,
  routeInviteAccept,
  routeListingInferenceReviewPortal,
  routeListingInferenceReviewPortalWithListing,
  routeLogin,
  routePasswordResetComplete,
  routePasswordResetRequest,
  routePaymentSetup,
  routeReview,
  routeReviewWithDocument,
  routeStatementClassifier,
} from "@ps-bridge/programs/routes";

const invalidRoutePath = "/__invalid-route__";

const renderRoute = (route: Route): string => {
  if (typeof route === "function") {
    console.error("renderRoute expected a Route value, not a route constructor function.");
    return invalidRoutePath;
  }
  return renderRouteUnsafe(route);
};

const listingInferenceReviewPortalRoutePattern = (): string =>
  `${renderRoute(routeListingInferenceReviewPortal)}/:listingId?`;

const contextPreviewConsoleRoutePattern = (): string =>
  `${renderRoute(routeContextPreviewConsole)}/:listingId?`;

const workspaceClientProjectRoutePattern = (): string =>
  `${renderRoute(routeClients)}/:clientId/projects/:projectId`;

const projectPageCounterRoutePattern = (): string =>
  `${workspaceClientProjectRoutePattern()}/page-counter`;
type PageCounterRouteExports = typeof routeProgram & { readonly routePageCounter: Route };
const routePageCounter = (routeProgram as PageCounterRouteExports).routePageCounter;
const routeProjectPageCounter = (clientId: ClientID) => (projectId: ProjectID): string =>
  `${renderRoute(routeClientsExplorerWithProject(clientId)(projectId))}/page-counter`;

export type { Route };
export {
  contextPreviewConsoleRoutePattern,
  listingInferenceReviewPortalRoutePattern,
  renderRoute,
  routeAccount,
  routeAdminPlan,
  routeAdminUsers,
  routeChooseSubscription,
  routeChooseSubscriptionWithStatus,
  routeClients,
  routeClientsExplorer,
  routeClientsExplorerWithClient,
  routeClientsExplorerWithProject,
  routeContextPreviewConsole,
  routeContextPreviewConsoleWithListing,
  routeCreateAccount,
  routeDemographicSurvey,
  routeDocumentCreation,
  routeDocumentDetailsPrompt,
  routeDocumentFinalEdits,
  routeDocumentFinalEditsWithContext,
  routeDocumentPrompt,
  routeDocumentRefine,
  routeDocumentRefineWithContext,
  routeDocumentSelection,
  routeEmailVerify,
  routeFeedback,
  routeHome,
  routeInviteAccept,
  routeListingInferenceReviewPortal,
  routeListingInferenceReviewPortalWithListing,
  routeLogin,
  routePasswordResetComplete,
  routePasswordResetRequest,
  routePageCounter,
  routePaymentSetup,
  routeReview,
  routeReviewWithDocument,
  routeStatementClassifier,
  projectPageCounterRoutePattern,
  routeProjectPageCounter,
  workspaceClientProjectRoutePattern,
};
